<template>
  <div class="nav">
    <router-link to="/">
      <i class="iconfont icon-shouye"></i>
      <span>{{lang.home}}</span>
    </router-link>
    <router-link to="/Quotation">
      <i class="iconfont icon-jinrongzoushitu"></i>
      <span>{{lang.market}}</span>
    </router-link>
    <router-link to="/Strategy">
      <i class="iconfont icon-qianbao"></i>
      <span>{{lang.ailh}}</span>
    </router-link>
    <router-link to="/My">
      <i class="iconfont icon-my"></i>
      <span>{{lang.my}}</span>
    </router-link>
  </div>
</template>
<script>
  import {
		mapState
	} from 'vuex'
  export default{
    data(){
        return {

        }
    },
    computed: {
			...mapState(['lang'])
		},
  }
</script>
<style scoped>
  /*底部样式*/
  .nav{
    width:100%;
    height: 54px;
    background: #1a1a1a;
    display: flex;
    color: #fff;
    position: absolute;
    bottom: 0;
  }
  .nav a{
    flex:1;
    display: flex;
    background: #1a1a1a;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color:#fff;

  }
  .nav a>span{
    font-size: 12px;
  }
  .nav a>i{
    font-size: 20px;
  }
  .nav a>i.icon-yejinkuangchan{
    font-size: 24px;
  }
  .nav a.router-link-exact-active{
    color:#c0dd2b;
  }
  .zhongjian{
    margin-bottom: 20px;
    padding: 10px;
    border-radius: 50%;
    box-shadow: 0.03333rem 0.03333rem 0.13333rem #0000003a;
    background: #fff
  }
</style>